import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServiceResponseModule } from '@sdbn/common';
import { TMCTableModule } from '@sdbn/common';
import { TransportLogComponent } from './transport-log.component';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule as MatInputModule } from '@angular/material/input';

@NgModule({
  imports: [
    CommonModule,

    FormsModule,
    ReactiveFormsModule,
    TMCTableModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatInputModule

  ],
  declarations: [
    TransportLogComponent
  ]
})
export class TransportLogModule { }
